// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__mHNod","mainWrapper":"Logo_mainWrapper__UehAL"};